import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useSiteContext } from "../contexts/SiteProvider";
import EFHeader from "./EFHeader";
import "./EFLTheme.scss";
import EFSideNav from "./EFSideNav";
import "./EFSubLayout.scss";

interface childrenProps {
  children: any;
}

const pageVariants = {
  initial: { opacity: 0, y: 14, scale: 0.995 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.22, ease: [0.4, 0, 0.2, 1] },
  },
  exit: {
    opacity: 0,
    y: -8,
    scale: 0.995,
    transition: { duration: 0.14, ease: [0.4, 0, 1, 1] },
  },
};

const EFSubLayout: React.FC<childrenProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const { isDark, setIsDark } = useSiteContext();
  const location = useLocation();

  const isMobile = () => window.innerWidth <= 768;

  return (
    <div
      className={`container is-fluid smart-dark-efl-container ${
        !isDark ? "smart-efl-container" : ""
      }`}
    >
      {/* Mobile backdrop — tap outside closes sidebar */}
      {isOpen && isMobile() && (
        <div
          className="efl-mobile-backdrop"
          onClick={() => setIsOpen(false)}
        />
      )}

      <div className="efl-main-sidenav">
        <EFSideNav isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>

      <div className={`efl-main-header ${isOpen ? "expanded" : ""}`}>
        <EFHeader
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          setIsDark={setIsDark}
          isDark={isDark}
        />
      </div>

      {/* Page transition wrapper */}
      <div className={`efl-main-div ${isOpen ? "expanded" : ""}`}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            style={{ minHeight: "100%" }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default EFSubLayout;
